import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FetchLandingPageAction } from "../../redux/action/LandingPageAction";
import { useAuth } from "../../utils/auth/useAuth";
import { LoadingSpinner } from "pepsico-ds";
import { Outlet, useNavigate } from "react-router-dom";


function CommodityLanding() {
	const dispatch = useDispatch();
	const { authState } = useAuth();
	const [userInfo, setUserInfo] = useState({});
	
	useEffect(() => {
		async function fetchUserInfo() {
			// const user = await getOktaUserClaims(getOktaAuth());
			// setUserInfo(user);
			// dispatch(FetchLandingPageAction(user));
		}
		fetchUserInfo();
	}, []);

	// const userData = useSelector((state) => state.getLandingPageReducer);
	
    /* istanbul ignore next */
    // useEffect(() => {
		
    // }, [userData])

	if(authState?.isAuthenticated){
		return(
			
                <>
                    <Outlet/>
                </>
		)
	}
}

export default CommodityLanding;